import React, { createContext, useContext, useState, useEffect } from 'react';

const CurrencyContext = createContext();

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const [selectedCurrency, setSelectedCurrency] = useState('MKD');

  // Load saved currency preference
  useEffect(() => {
    const savedCurrency = localStorage.getItem('selectedCurrency');
    if (savedCurrency) {
      setSelectedCurrency(savedCurrency);
    }
  }, []);

  // Listen for currency changes from mobile menu
  useEffect(() => {
    const handleCurrencyChange = (event) => {
      setSelectedCurrency(event.detail.currency);
    };

    window.addEventListener('currencyChanged', handleCurrencyChange);
    return () => window.removeEventListener('currencyChanged', handleCurrencyChange);
  }, []);

  // Format price based on selected currency
  const formatPrice = (price) => {
    if (!price || isNaN(price)) return '';
    
    const numPrice = parseFloat(price);
    
    switch (selectedCurrency) {
      case 'MKD':
        // Macedonian format: 1950 MKD (no decimal places)
        return `${Math.round(numPrice)} MKD`;
      case 'EUR':
        // European format: 19,50 EUR (with comma as decimal separator)
        // Conversion rate: 1 EUR = 61.5 MKD
        const eurPrice = numPrice / 61.5;
        return `${eurPrice.toFixed(2).replace('.', ',')} EUR`;
      default:
        return `${Math.round(numPrice)} MKD`;
    }
  };

  const changeCurrency = (currencyCode) => {
    setSelectedCurrency(currencyCode);
    localStorage.setItem('selectedCurrency', currencyCode);
    
    // Trigger event for other components
    window.dispatchEvent(new CustomEvent('currencyChanged', { 
      detail: { currency: currencyCode } 
    }));
  };

  const value = {
    selectedCurrency,
    formatPrice,
    changeCurrency,
    availableCurrencies: [
      { code: 'MKD', name: 'North Macedonia', symbol: 'MKD ден.' },
      { code: 'EUR', name: 'Albania', symbol: 'EUR €' },
      { code: 'EUR', name: 'Kosovo', symbol: 'EUR €' },
      { code: 'EUR', name: 'Serbia', symbol: 'EUR €' }
    ]
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};